import React from "react";
import ConfirmDeleteDialog from "../../common/ConfirmDeleteDialog";
import { useEnumStrings } from "../../enumStrings";

interface DeleteBannerModalProps {
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
}

const DeleteBannerModal: React.FC<DeleteBannerModalProps> = ({
    open,
    onClose,
    onDelete,
}) => {
    const enumStrings = useEnumStrings();

    return (
        <ConfirmDeleteDialog
            open={open}
            onClose={onClose}
            onDelete={onDelete}
            title={enumStrings.bannerUpload.deleteBannerTitle}
            confirmText={enumStrings.bannerUpload.deleteBannerConfirm}
            description={enumStrings.bannerUpload.deleteBannerDescription}
            buttonLabel={enumStrings.bannerUpload.delete}
        />
    );
};

export default DeleteBannerModal;
